import { useCallback, useEffect, useState } from 'react';

const getMatches = (matchQuery: string): boolean => {
  // Prevents SSR issues
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia(matchQuery).matches;
  }
  return true;
};

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => getMatches(query));

  const handleChange = useCallback(() => {
    setMatches(getMatches(query));
  }, [query]);

  useEffect(() => {
    const matchMedia = window.matchMedia(query);

    // Triggered at the first client-side load and if query changes
    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [handleChange, query]);

  return matches;
}

export default useMediaQuery;
